import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'
import { wording } from "src/constants/constants.js";

export const FETCH_DELIVERY_STATUS_LIST = 'FETCH_DELIVERY_STATUS_LIST'
export const RECEIVE_DELIVERY_STATUS_LIST = 'RECEIVE_DELIVERY_STATUS_LIST'
export const FAILED_DELIVERY_STATUS_LIST = 'FAILED_DELIVERY_STATUS_LIST'

export function fetchDeliveryStatusList(){

    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_DELIVERY_STATUS_LIST});
        axios({
            method: 'post',
            url: API_LINKS.DELIVERY_STATUS_LIST_URL,
            headers: {
                Authorization: auth
            },
            data: {
                // id_delivery_order: '1',
                // day: _day
                // date: 
                // For Parameters
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_DELIVERY_STATUS_LIST,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error("Failed in fetching "+wording["Delivery Order"]+"s List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_DELIVERY_STATUS_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_DELIVERY_STATUS_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}